import PropTypes from 'prop-types';

import '../../styles/flight-path/button.scss';

const Button = (props) => {
  const {
    backgroundColor,
    children,
    disabled,
    id,
    label,
    onClick,
    labelColor,
    type,
    isLoading = false,
    customClassName = ''
  } = props;

  const buttonTheme = {
    primary: {
      backgroundColor,
      color: labelColor
    },
    outlined: {
      border: `1px solid ${labelColor}`,
      color: labelColor
    },
    transparent: {
      backgroundColor: 'transparent'
    }
  };

  return (
    <button
      id={id}
      onClick={onClick}
      type="button"
      disabled={disabled || isLoading}
      className={`button ${type} ${customClassName}`}
      style={buttonTheme[type]}
    >
      {isLoading ? <div className="loader-spinner-animation" /> : label || children}
    </button>
  );
};

Button.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  labelColor: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'outlined']),
  isLoading: PropTypes.bool,
  customClassName: PropTypes.string
};

Button.defaultProps = {
  backgroundColor: '',
  children: <></>,
  disabled: false,
  id: '',
  label: '',
  onClick: () => {},
  labelColor: '',
  type: 'primary',
  isLoading: false,
  customClassName: ''
};

export default Button;
